import {Component, ViewContainerRef} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {DatePipe} from "@angular/common";

export const MY_FORMATS = {
   parse: {
      dateInput: "DD/MM/YYYY"
   },
   display: {
      dateInput: "DD/MM/YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD/MM/YYYY",
      monthYearA11yLabel: "MMMM YYYY"
   }
};

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss'],
   providers: [
      {
         provide: DateAdapter,
         useClass: MomentDateAdapter,
         deps: [MAT_DATE_LOCALE]
      },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
      DatePipe
   ]
})
export class AppComponent {
   public static vcr : ViewContainerRef
   title = 'ngApp';

   constructor(private spinner: NgxSpinnerService,
               private matIconRegistry: MatIconRegistry,
               private vcr: ViewContainerRef,
               private domSanitizer: DomSanitizer) {

      AppComponent.vcr = vcr
      this.spinner.show();

      this.matIconRegistry.addSvgIcon(
         "barcode_24",
         this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/icons/barcode_24.svg")
      );

      this.matIconRegistry.addSvgIcon(
         "barcode",
         this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/icons/barcode.svg")
      );

   }
}
